import React, { useContext } from "react";
import { Grid, TextField, InputAdornment } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import FacebookCampaignContext from "../../../../context/facebook_profiles/campaign/CampaignContext";

// Components
import TransferList from "./TransferList";

const useStyles = makeStyles((theme) => ({}));

const CampaignForm = () => {
  const classes = useStyles();

  const {
    list_special_ad,
    list_status,
    list_objective,
    list_bid,
    form_details,
    setFormDetails,
    form_errors,
    setFormErrors,
  } = useContext(FacebookCampaignContext);

  const handleChange = (e) => {
    const id = e.target.id;
    let value = e.target.value;

    // Regex
    const validPricing = /^[0-9]{1,}\.{0,1}[0-9]*$/;

    switch (id) {
      case "name":
        if (value.length < 1) {
          form_errors[id] = "Name cannot be empty!";
        } else if (value.length > 50) {
          form_errors[id] = "Name cannot be more than 50 characters!";
        } else {
          form_errors[id] = "";
        }
        break;

      case "daily_budget":
        if (value.length < 1) {
          form_errors[id] = "Daily Budget cannot be empty!";
        } else {
          if (!validPricing.test(value)) {
            form_errors[id] = "Daily Budget must be a numeric value!";
          } else {
            form_errors[id] = "";
          }
        }
        break;

      case "status":
      case "objective":
      case "bid_strategy":
        if (value) form_errors[id] = "";
        break;

      default:
        break;
    }

    setFormDetails({ ...form_details, [id]: value });
    setFormErrors(form_errors);
  };

  const handleTransferList = (list) => {
    const id = "special_ad_categories";

    if (list.length === 0) {
      form_errors[id] = "Special Ad Categories cannot be empty!";
    } else {
      form_errors[id] = "";
    }

    setFormDetails({ ...form_details, [id]: list });
    setFormErrors(form_errors);
  };

  return (
    <Grid item container spacing={1}>
      <Grid item xs={4}>
        <TextField
          required
          fullWidth
          variant="outlined"
          size="small"
          margin="dense"
          label="Name"
          id="name"
          name="name"
          value={form_details.name}
          onChange={handleChange}
          error={form_errors.name ? true : false}
          helperText={form_errors.name ? form_errors.name : ""}
        />{" "}
      </Grid>
      <Grid item xs={4}>
        <TextField
          required
          fullWidth
          variant="outlined"
          size="small"
          margin="dense"
          label="Daily Budget"
          id="daily_budget"
          name="daily_budget"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <span
                  style={{
                    fontSize: "0.9rem",
                  }}
                >
                  {" "}
                  ${" "}
                </span>{" "}
              </InputAdornment>
            ),
          }}
          value={form_details.daily_budget}
          onChange={handleChange}
          error={form_errors.daily_budget ? true : false}
          helperText={form_errors.daily_budget ? form_errors.daily_budget : ""}
        />{" "}
      </Grid>
      <Grid item xs={4}>
        <TextField
          required
          fullWidth
          variant="outlined"
          select
          SelectProps={{
            native: true,
          }}
          size="small"
          margin="dense"
          label="Status"
          id="status"
          name="status"
          value={form_details.status ? form_details.status : "select"}
          onChange={handleChange}
          error={form_errors.status ? true : false}
          helperText={form_errors.status ? form_errors.status : ""}
        >
          <option value="select" disabled>
            -- - select one-- -
          </option>{" "}
          {list_status.map((each, index) => {
            return (
              <option key={index} value={each}>
                {" "}
                {each}{" "}
              </option>
            );
          })}{" "}
        </TextField>{" "}
      </Grid>
      <Grid item xs={6}>
        <TextField
          required
          fullWidth
          variant="outlined"
          select
          SelectProps={{
            native: true,
          }}
          size="small"
          margin="dense"
          label="Objective"
          id="objective"
          name="objective"
          value={form_details.objective ? form_details.objective : "select"}
          onChange={handleChange}
          error={form_errors.objective ? true : false}
          helperText={form_errors.objective ? form_errors.objective : ""}
        >
          <option value="select" disabled>
            -- - select one-- -
          </option>{" "}
          {list_objective.map((each, index) => {
            return (
              <option key={index} value={each}>
                {" "}
                {each}{" "}
              </option>
            );
          })}{" "}
        </TextField>{" "}
      </Grid>
      <Grid item xs={6}>
        <TextField
          required
          fullWidth
          variant="outlined"
          select
          SelectProps={{
            native: true,
          }}
          size="small"
          margin="dense"
          label="Bid Strategy"
          id="bid_strategy"
          name="bid_strategy"
          value={
            form_details.bid_strategy ? form_details.bid_strategy : "select"
          }
          onChange={handleChange}
          error={form_errors.bid_strategy ? true : false}
          helperText={form_errors.bid_strategy ? form_errors.bid_strategy : ""}
        >
          <option value="select" disabled>
            -- - select one-- -
          </option>{" "}
          {list_bid.map((each, index) => {
            return (
              <option key={index} value={each}>
                {" "}
                {each}{" "}
              </option>
            );
          })}{" "}
        </TextField>{" "}
      </Grid>
      <TransferList
        title="Special Ad Categories *"
        data_list={list_special_ad}
        handleTransferList={handleTransferList}
        errorMessage={form_errors.special_ad_categories}
      />{" "}
    </Grid>
  );
};

export default CampaignForm;
